<template>
    <div class="flex-column ai-center">
        <header class="w-5 acenter">
            <h1>{{ $l10n.__('Identifiez-vous') }}</h1>
            <p>
                {{
                    $l10n.__(
                        'Afin de compléter la synchronisation de votre compte sur Sellsy, saisissez vos identifiants et mot de passe.',
                    )
                }}
            </p>
        </header>
        <div
            id="email_msg"
            class="label label-nobackground danger aleft mt-1 pl-0 formAlert"
            style="display: none"
        >
            <span></span>
        </div>
        <!-- form -->
        <el-form
            ref="form"
            class="b-1 mt-7 py-4 px-3 w-4 flex-column ai-center relative"
            :model="form"
            :rules="rules"
        >
            <SaasIcon icon="svgOffice365" :width="35" :height="35" />
            <h2 class="mt-2 mb-4">{{ $l10n.__('Office 365') }}</h2>

            <el-form-item
                class="wp-10"
                :label="$t.__('common.labels.your_email_address')"
                prop="email_address"
                :error="errors.get('email_address')"
            >
                <TextInput
                    mode="edit"
                    :readonly="login_hint ? true : false"
                    :modelValue="form.email_address"
                    @update:modelValue="updateLogin"
                />
            </el-form-item>
            <el-form-item
                class="wp-10 mb-5"
                :label="$t.__('common.labels.password')"
                prop="email_password"
                :error="errors.get('email_password')"
            >
                <el-input
                    type="password"
                    showPassword
                    :modelValue="form.email_password"
                    @input="updatePassword"
                />
            </el-form-item>

            <!-- call to action -->
            <div class="action self-center">
                <CompassButton
                    :label="$t.__('pages.onboarding.email.sync.OnboardingEmailSyncOffice365.login')"
                    type="primary"
                    class="self-center"
                    @click="submitForm('form', 'signIn')"
                />
            </div>

            <!-- Loader -->
            <div><preloader :display="loading" /></div>
        </el-form>
    </div>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import FormMixins from 'mixins/FormMixins';
import TextInput from 'vcomponents/inputs/TextInput.vue';
import OnboardingEmailSyncOffice365Rules from 'vcomponents/forms/rules/OnboardingEmailSyncOffice365Rules';
import OnboardingEmailApi from 'api/onboarding/email/onboardingEmail.js';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    name: 'OnboardingEmailSyncOffice365',
    components: {
        SaasIcon,
        Preloader,
        TextInput,
    },
    mixins: [FormMixins],
    data() {
        return {
            loading: false,
            provider: null,
            login_hint: null,
            fields: [],
            form: {
                email_provider: '',
                email_address: '',
                email_password: '',
            },
            rules: OnboardingEmailSyncOffice365Rules,
            finalPageName: 'onboarding.email.final',
        };
    },
    created() {
        this.provider = this.$attrs.provider;
        this.email_provider = this.provider.id;
        if (this.$attrs.login_hint)
            this.form.email_address = this.login_hint = this.$attrs.login_hint;
        if (this.$attrs.finalPageName) this.finalPageName = this.$attrs.finalPageName;
    },
    mounted() {
        this.fields = this.$refs.form.fields;
    },
    methods: {
        /**
         * Update login
         *
         * @param {string} login
         * @return {void}
         *
         */
        updateLogin(login) {
            this.form.email_address = login;
        },
        /**
         * Update password
         *
         * @param {string} password
         * @return {void}
         */
        updatePassword(password) {
            this.form.email_password = password;
        },
        /**
         * Submit form to connect with the provider
         *
         * @return {void}
         */
        signIn() {
            this.loading = true;

            OnboardingEmailApi.validateSignIn(this.form, {
                _f: 'prefsNylas',
                action: 'oauthMicrosoftOffice365',
            })
                .then(
                    ({ form }) => {
                        if (form.status === 'ok') {
                            new Promise((resolve) => resolve())
                                .then((res) =>
                                    OnboardingEmailApi.validateOnboardingEmailStep(4, {
                                        provider: this.provider,
                                    }),
                                )
                                .then((res) => this.goToFinalPage())
                                .catch((err) =>
                                    Push.error(this.$l10n.__('Une erreur est survenue'), false),
                                );
                        } else if (form.status === 'failed') {
                            const failedMsg = !!form.msg
                                ? form.msg
                                : this.$l10n.__('Une erreur est survenue lors de la connexion');
                            const error = form.fields.reduce(
                                (obj, { fieldId, msg }) => ({ ...obj, [fieldId]: msg }),
                                {},
                            );
                            this.displayError(error, failedMsg);
                        }
                    },
                    (error) => this.displayError(error),
                )
                .finally(() => (this.loading = false));
        },
        /**
         * Display connection errors with the provider
         *
         * @param {object} error object of error by field
         * @param {string} msg message displayed on the cause of the error
         * @return {void}
         */
        displayError(error, msg = 'Une erreur est survenue lors de la connexion') {
            Push.error(this.$l10n.__(msg), false);
            this.errors.setErrors(error);
        },
        /**
         * Redirect to onboarding email final page
         *
         * @return {void}
         */
        goToFinalPage() {
            this.$router.push({ name: this.finalPageName, params: { provider: this.provider } });
        },
    },
};
</script>
